import React from 'react';
import { Col, Form } from 'react-bootstrap';

// Email
const EmailInput = ({ formFound, values, handleInputChange, validateEmail }) => {
  return (
    <Col lg={4} xs={12} className="mb-3">
      <Form.Group controlId={'validationCustom'}>
        <Form.Label>{formFound?.email?.name + ' *'}</Form.Label>
        <Form.Control
          name="email"
          type="email"
          required
          placeholder={formFound?.email?.placeholder}
          onChange={handleInputChange}
          isValid={validateEmail(values.email)}
          isInvalid={values.email?.length > 0 && !validateEmail(values.email)}
        />
        <Form.Control.Feedback type="invalid">
          Ingrese un mail válido por favor
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default EmailInput;
